import { CEConstraintAttributesBase } from './ce-constraint-attributes-base'


export class CEConstraintAttributes extends CEConstraintAttributesBase {

}